const formatDate = () => {
  const inputDate = new Date();
  const year = inputDate.getFullYear();
  const month = `${inputDate.getMonth() + 1}`.padStart(2, "0");
  const formattedDate = `${inputDate.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${formattedDate}`;
};
export default formatDate;
